import styled from '@emotion/styled';
import { colors, typography, spacing } from '../../../theme';

export const ErrorContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing.xl}px;
  background: var(--bg-canvas);
`;

export const ErrorCard = styled.div`
  max-width: 600px;
  width: 100%;
  background: var(--bg-elevated);
  border: 1px solid var(--border-default);
  border-radius: 16px;
  padding: ${spacing['3xl']}px;
  text-align: center;
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-lg);
  animation: slideIn 0.5s ease-out;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ErrorIcon = styled.div`
  font-size: 80px;
  margin-bottom: ${spacing.lg}px;
  animation: pulse 2s ease-in-out infinite;

  @keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.1); }
  }
`;

export const ErrorTitle = styled.h1`
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize['2xl']};
  font-weight: ${typography.fontWeight.bold};
  color: var(--fg-primary);
  margin-bottom: ${spacing.md}px;
`;

export const ErrorMessage = styled.p`
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.lg};
  color: var(--fg-secondary);
  margin-bottom: ${spacing.xl}px;
  line-height: ${typography.lineHeight.relaxed};
`;

export const ErrorDetails = styled.div`
  background: var(--bg-hover);
  border: 1px solid var(--border-default);
  border-radius: 8px;
  padding: ${spacing.lg}px;
  margin-bottom: ${spacing.xl}px;
  text-align: left;
`;

export const ErrorDetailsTitle = styled.div`
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.sm};
  font-weight: ${typography.fontWeight.semibold};
  color: ${colors.cautionRed};
  margin-bottom: ${spacing.sm}px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ErrorCode = styled.code`
  font-family: ${typography.fontFamily.code};
  font-size: ${typography.fontSize.sm};
  color: var(--fg-primary);
  word-break: break-word;
  display: block;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: ${spacing.md}px;
  justify-content: center;
  margin-bottom: ${spacing.lg}px;
`;

export const ReloadButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${spacing.sm}px;
  padding: ${spacing.md}px ${spacing.xl}px;
  background: linear-gradient(135deg, ${colors.honestTeal} 0%, ${colors.deepTrustBlue} 100%);
  border: none;
  border-radius: 12px;
  color: var(--fg-on-accent);
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.base};
  font-weight: ${typography.fontWeight.semibold};
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 191, 166, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 191, 166, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const HomeButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${spacing.sm}px;
  padding: ${spacing.md}px ${spacing.xl}px;
  background: var(--bg-hover);
  border: 1px solid var(--border-default);
  border-radius: 12px;
  color: var(--fg-primary);
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.base};
  font-weight: ${typography.fontWeight.semibold};
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: var(--bg-active);
    border-color: ${colors.honestTeal};
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ErrorFooter = styled.div`
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.sm};
  color: var(--fg-muted);
  font-style: italic;
`;
